import { Button, Modal } from 'react-bootstrap'
import { PapeletaDataProvider } from './PapeletaDataProvider'
import { PapeletaView } from './PapeletaView'
import { X } from 'lucide-react'

export function PapeletaViewModal({ id, onClose, ...props }) {
    return (
        <Modal dialogClassName='max-w-modal w-300' {...props} centered>
            <Modal.Header className='py-2'>
                <Modal.Title>Papeleta de pago de pasajes y/o viáticos</Modal.Title>
            </Modal.Header>
            <div className='px-3 py-2'>
                <div className='min-h-48 flex flex-col'>
                    <PapeletaDataProvider id={id} orientation='vertical'>
                        {(papeleta) => <PapeletaView papeleta={papeleta} />}
                    </PapeletaDataProvider>
                </div>
            </div>
            <Modal.Footer className='py-2'>
                <Button onClick={onClose}>
                    <X className='size-4' />
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
